import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../hooks'
import { FormikForm } from '../../../Formik'

import { useApplicantFormSubmit } from './RentalPortalApplicantForm.hooks'
import {
  getApplicantFormInitialValues,
  getApplicantFormValidationSchema,
} from './RentalPortalApplicantForm.utils'
import { RentalPortalApplicantFormFields } from './RentalPortalApplicantFormFields'

import * as styles from './RentalPortalApplicantForm.module.css'

function RentalPortalApplicantForm({
  FormContainer,
  containerProps,
  initialValues,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const { handleSubmit } = useApplicantFormSubmit({ onSuccess })

  return (
    <FormikForm
      Container={FormContainer}
      containerProps={containerProps}
      formProps={{ className: styles.formBody }}
      initialValues={getApplicantFormInitialValues(initialValues)}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getApplicantFormValidationSchema(t)}
      onSubmit={handleSubmit}
    >
      <RentalPortalApplicantFormFields
        {...restProps}
        notifications={notifications}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RentalPortalApplicantForm
